import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { usePurchasingShippingMethodsTable } from 'src/pages/settings/admin/purchasingShippingMethods/usePurchasingShippingMethodsTable';

export const PurchasingShippingMethodsTablePage = () => {
    const [columns, tableSettings] = usePurchasingShippingMethodsTable();
    return (
        <>
            <PageHeader {...{
                title: "Purchasing Shipping Methods", subTitle: "View shipping methods for suppliers and manufacturers",
                components: generateTablePageButtons(tableSettings),
            }} />
            <ContentCardsContainer>
                <ContentCard cardId="Purchasing Shipping Methods" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default PurchasingShippingMethodsTablePage;
